import { useQuery } from "react-query";
import { sureApiCall } from "src/api/axiosClient/sureApi";
import { z } from "zod";
import { zodParseWithLog } from "../apiErrorLogs";

export const getOneProductReferenceApiKey = "productRefOneKey" as const;

type Options = {
    id?: number;
};

export const useGetOneProductReference = (options?: Options) => {
    const { id } = options || {};

    const queryResult = useQuery({
        queryKey: [getOneProductReferenceApiKey, id],
        enabled: id !== undefined,
        queryFn: async () => {
            const url = `/api/product_references/${id}`;
            const response = await sureApiCall.get(url);
            return response;
        },
        select: (request) => {
            const productReference = request.data;
            const data = zodParseWithLog(productReference, ProductReferenceSchema, getOneProductReferenceApiKey);
            return data;
        },
    });

    return {
        productReference: queryResult.data,
        ...queryResult,
    };
};

export type ProductReference = {
    id: number;
    name: string;
};

const ProductReferenceSchema: z.ZodSchema<ProductReference> = z.object({
    id: z.number(),
    name: z.string(),
});
